import { DEFAULT_TOOL_TIP_DELAY } from './Tooltip.types';
import type { QTipDataAttributes } from './QTip.types';
import type { TooltipComponentProps } from './Tooltip.types';

export const getQTipData = ({
  tooltip,
  tooltipPlacement,
  isHtmlTooltip,
  tooltipTestId,
  tooltipDelay = DEFAULT_TOOL_TIP_DELAY,
}: TooltipComponentProps): QTipDataAttributes | undefined =>
  tooltip
    ? {
        'data-qtip-text': tooltip,
        'data-qtip-placement': tooltipPlacement,
        'data-qtip-is-html': isHtmlTooltip,
        'data-qtip-testid': tooltipTestId,
        'data-qtip-delay': tooltipDelay,
      }
    : undefined;
